import { RootState } from 'redux/root-reducer';

const fullScreenSelector = {
  content: (state: RootState) => state.fullScreenView.content,
  onCloseAdditionalAction: (state: RootState) =>
    state.fullScreenView.onCloseAdditionalAction,
};

export default fullScreenSelector;
